// @flow

import React from 'react';

import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import Toggle from 'react-toggled';
import { withTranslation } from 'react-i18next';
import ClosedCaptionOutlinedIcon from '@material-ui/icons/ClosedCaptionOutlined';
import ZoomBroadcastCaptionsPopupContainer from './ZoomBroadcastCaptionsPopupContainer';

interface IProps {
  t: Function;
}

function ZoomBroadcastCaptionsMenuItem(props: IProps) {
  return (
    <Toggle>
      {({ on, setOn, setOff }) => (
        <>
          <ListItem
            onClick={setOn}
            style={{
              paddingLeft: 32,
            }}
            role="button"
            button
          >
            <ListItemIcon>
              <ClosedCaptionOutlinedIcon />
            </ListItemIcon>
            <ListItemText>{props.t('conversation.zoomExport.broadcastToZoom')}</ListItemText>
          </ListItem>
          <ZoomBroadcastCaptionsPopupContainer on={on} setOff={setOff} />
        </>
      )}
    </Toggle>
  );
}

export default withTranslation()(ZoomBroadcastCaptionsMenuItem);
